export default {
  roundtrip: {
    'roundtripOptions': 'Opzioni di andata e ritorno'
  }
}
